import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Button,
  Container,
  Divider,
  Form,
  Header,
  Icon,
  List,
  Menu,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import NavPages from './../../navigation/NavPages';
import ItemList from './../../lists/ItemList';

const INITIAL_STATE = {
  searchForm: {
    loading: false,
    values: {
      matriculaNacional: '',
      matriculaProvincial: ''
    },
    error: null
  },
  cooperativas: []
};

class InformeEconomicoView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
  }

  createInputHandler (name, type = 'input') {
    return (e, input) => {
      let valueSelector = {
        input: () => {
          return e.target.value;
        },
        select: () => {
          return input.value;
        }
      };

      this.changeFormValue(name, valueSelector[type]());
    };
  }

  changeFormValue (name, value) {
    let {
      searchForm
    } = this.state;

    this.setState({
      searchForm: {
        ...searchForm,
        values: {
          ...searchForm.values,
          [name]: value
        }
      }
    });
  }

  findCooperativas (matriculaNacional, matriculaProvincial) {
    return this.CooperativaService.find({
      query: {
        matriculaNacional,
        matriculaProvincial,
        skip: 0,
        limit: 10
      }
    });
  }

  submitSearch (e) {
    e.preventDefault();

    let {
      searchForm: {
        values
      }
    } = this.state;

    this.setState({
      searchForm: {
        ...this.state.searchForm,
        loading: true,
        error: null
      },
      cooperativas: []
    });

    this.findCooperativas(values.matriculaNacional, values.matriculaProvincial)
      .then(response => {
        this.setState({
          searchForm: {
            ...this.state.searchForm,
            loading: false
          },
          cooperativas: response.records
        });
      })
      .catch(error => {
        this.setState({
          searchForm: {
            ...this.state.searchForm,
            loading: false,
            error
          }
        });
      });
  }

  mapCooperativaToItemList = (cooperativas) => cooperativas.map((cooperativa) => ({
    id: cooperativa.id,
    header: cooperativa.nombre,
    description: `MN: ${cooperativa.matriculaNacional} MP: ${cooperativa.matriculaProvincial}`
  }))

  selectCooperativa (cooperativa) {
    window.open(`/reporte?type=matricula&id=${cooperativa.id}`);
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      cooperativas,
      searchForm
    } = this.state;

    return (
      <div>
        <Form onSubmit={this.submitSearch.bind(this)}>
          <Form.Group inline>
            <Form.Input
              label="Matricula Nacional"
              value={searchForm.values.matriculaNacional}
              onChange={this.createInputHandler('matriculaNacional', 'input')} />
            <Form.Input
              label="Matricula Provincial"
              value={searchForm.values.matriculaProvincial}
              onChange={this.createInputHandler('matriculaProvincial', 'input')} />
            <Button
              type="submit" disabled={searchForm.loading} onClick={this.submitSearch.bind(this)}
              content={searchForm.loading ? 'Cargando...' : 'Buscar'} icon="search" />
          </Form.Group>
        </Form>
        <Divider />
        <ItemList data={this.mapCooperativaToItemList(cooperativas)} loading={searchForm.loading} selectItem={this.selectCooperativa.bind(this)} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    InformeEconomicoView.mapStateToProps,
    InformeEconomicoView.mapDispatchToProps
  )(InformeEconomicoView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/InformeEconomicoView.js